<template>
    <div>
        <b-table
        class="m-b-30"
        :data="count > 0 ? orders : []"
        :loading="loading"
        :hoverable="true">
            <template slot-scope="props">
                <b-table-column label="ID" width="40">
                    <a :href="detailUrl+'?order_pk='+props.row.id">#{{ props.row.id }}</a>
                </b-table-column>
                <b-table-column label="Comprador">
                    <a :href="detailUrl+'?order_pk='+props.row.id">{{ props.row.orderdata.email }}</a>
                </b-table-column>
                <b-table-column field="timestamp" label="Creado" centered>
                    <span class="tag is-info">
                        {{ new Date(props.row.timestamp).toLocaleDateString() }}
                    </span>
                </b-table-column>
                <b-table-column label="Estado">
                    <span class="tag" :class="statusSwitch(props.row.status)">{{props.row.getStatusDisplay}}</span>
                </b-table-column>
                <b-table-column label="Metodo de envio">
                    <p>{{props.row.orderdata.getShipmentMethodDisplay}}</p>
                </b-table-column>
                <b-table-column label="Total Uy">
                    <p>{{props.row.payment.amountUy}}</p>
                </b-table-column>
                <b-table-column label="Total USD">
                    <p>{{props.row.payment.amountUsd}}</p>
                </b-table-column>
            </template>
            <template slot="empty">
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p>
                            <b-icon
                                icon="frown"
                                size="is-large">
                            </b-icon>
                        </p>
                        <p>Nothing here.</p>
                    </div>
                </section>
            </template>
        </b-table>

        <div class="m-top-30">
            <b-pagination
                :total="count"
                :per-page="perPage"
                :current.sync="page"
                :range-before="2"
                :rounded="true"
                :range-after="2"
                order="is-centered"
                @change="onPageChange"
                icon-prev="chevron-left"
                icon-next="chevron-right"
            >
            </b-pagination>
        </div>
    </div>
</template>

<script>
import { getHandler } from '../../../services/http'
export default {
    props:{
        listUrl:{
            type:String,
            default:""
        },
        detailUrl:{
            type:String,
            default:""
        }
    },
    data(){
        return{
            loading:false,
            orders:[],
            count:0,
            perPage:24,
            page:1
        }
    },
    methods:{
        async fetchOrders(){
            this.loading = true
            let url = this.listUrl + "?page=" + this.page
            let resp = await getHandler(url, {error:false, success:false})
            this.orders = resp.results
            this.count = resp.count
            this.loading = false
        },
        onPageChange(page){
            this.page = page
            this.fetchOrders()   
        },
        statusSwitch(status){
            switch (status){
                case 'P':
                    return 'is-info'
                    break
                case 'A':
                    return 'is-success'
                    break
                case 'D':
                    return 'is-danger'
                    break
                case 'SA':
                    return 'is-warning'
                    break
                case 'SA':
                    return 'is-warning'
                    break
                case 'R':
                    return 'is-danger'
                    break
                case 'S':
                    return 'is-success'
                    break
                case 'F':
                    return 'is-success'
                    break
            }
        }
    },
    created(){
        this.fetchOrders()
    }
}
</script>